/**
 * Generates an attribute ID from a name, following the format ^[a-z]+[a-z1-9_]*
 * Ensures it starts with a letter and contains only lowercase letters, numbers, and underscores.
 */
export function makeAttributeId(name: string): string {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9_ ]/g, "") // Remove everything except lowercase letters, digits, underscores, and spaces
    .trim()
    .replace(/\s+/g, "_") // Replace spaces with underscores
    .replace(/^[^a-z]+/, "") // Ensure it starts with letters
    .replace(/_{2,}/g, "_") // Replace multiple underscores with one
    .replace(/^_/, "") // Remove leading underscore
    .replace(/_$/, ""); // Remove trailing underscore
}
